// extracted by mini-css-extract-plugin
export default {"ColaboratorsModuleAdminPage":"ColaboratorsModuleAdminPage_ColaboratorsModuleAdminPage__4S84U"};